<script setup lang="ts">
import { Head } from '@inertiajs/vue3'

import NotificationList from '@/components/notifications/NotificationList.vue'
import AppLayout from '@/layouts/AppLayout.vue'
import { destroyAllNotificationsPath, notificationPath, readAllNotificationsPath, readNotificationPath } from '@/routes'
import type { Notification } from '@/types'

defineProps<{ notifications: Notification[] }>()
</script>

<template>
  <Head title="Notifications" />
  <AppLayout>
    <NotificationList
      :notifications="notifications"
      :read-path="(id: number) => readNotificationPath(id)"
      :read-all-path="readAllNotificationsPath()"
      :delete-path="(id: number) => notificationPath(id)"
      :delete-all-path="destroyAllNotificationsPath()"
    />
  </AppLayout>
</template>
